import useAzureDevOpsDatasourceRepo from '@/composables/integrations/azure-dev-ops/azure-dev-ops-datasource-repo';
import useLoggedInUser from '@/composables/logged-in-user/logged-in-user';
import useRepo from '@/nebula/repo';
import { azureDevOpsQuery as azureDevOpsQueryConfig } from 'shared/api/query/configs.json';
import { customDatasourceProperty } from 'shared/constants.json';

export default function useAzureDevOps() {
  const queryRepo = useRepo(azureDevOpsQueryConfig.model);
  const datasourceRepo = useAzureDevOpsDatasourceRepo();

  const { loggedInUser } = useLoggedInUser();

  const createQuery = (entity) => queryRepo.createSingle({
    ...entity,
    creator: { uid: loggedInUser.value.uid },
  });

  const getProjects = (datasource, organization) => datasourceRepo.getProjects({
    ...datasource,
    [customDatasourceProperty.azureDevOpsOrganizations]: [organization],
  });
  const getProject = (datasource, organization, project) => datasourceRepo.getProject({
    ...datasource,
    [customDatasourceProperty.azureDevOpsOrganizations]: [organization],
    [customDatasourceProperty.azureDevOpsProjects]: [project],
  });

  const getSharedQueries = (datasource, organization, project) => datasourceRepo.getSharedQueries({
    ...datasource,
    [customDatasourceProperty.azureDevOpsOrganizations]: [organization],
    [customDatasourceProperty.azureDevOpsProjects]: [project],
  });

  const getWorkItemsBySharedQuery = (datasource, organization, project, query) => datasourceRepo.getWorkItemsBySharedQuery({
    ...datasource,
    [customDatasourceProperty.azureDevOpsOrganizations]: [organization],
    [customDatasourceProperty.azureDevOpsProjects]: [project],
    [customDatasourceProperty.azureDevOpsSharedQueries]: [query],
  });

  const getWorkItemsByType = (datasource, organization, project, type) => datasourceRepo.getWorkItemsByType({
    ...datasource,
    [customDatasourceProperty.azureDevOpsOrganizations]: [organization],
    [customDatasourceProperty.azureDevOpsProjects]: [project],
    [customDatasourceProperty.azureDevOpsWorkItemType]: [type],
  });

  return {
    createQueryLoading: queryRepo.createLoading,
    createQuery,
    updateQueryLoading: queryRepo.updateLoading,
    updateQuery: (entity) => queryRepo.updateSingle(entity, { ignoreResponse: false }),
    deleteQueryLoading: queryRepo.deleteLoading,
    deleteQuery: queryRepo.deleteSingle,

    getProjectsLoading: datasourceRepo.getProjectsLoading,
    getProjects,
    getProject,
    getSharedQueriesLoading: datasourceRepo.getSharedQueriesLoading,
    getSharedQueries,
    getWorkItemsLoading: datasourceRepo.getWorkItemsLoading,
    getWorkItemsBySharedQuery,
    getWorkItemsByType,
  };
}
